import { render, staticRenderFns } from "./BlackGoldTelegramFab.vue?vue&type=template&id=326ebf98"
import script from "./BlackGoldTelegramFab.vue?vue&type=script&lang=js"
export * from "./BlackGoldTelegramFab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports